<template>
  <div class="daily-withdraw-limit-container">
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="tab"
      :form-props="{ labelPosition: 'left' }"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-attrs="tableAttrs"
    >
      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
          <el-button type="primary" size="mini" @click="handleShowLog">操作记录</el-button>
        </div>
      </template>
      <template #username="{ row }">
        <MemberAccountCell :row="row" :username="row.username" :uid="row.uid" :vip-level="row.vip_level" />
      </template>
      <template #colPayoutLimit="{ row }">{{ row.payout_limit | centsToYuan }}</template>
      <template #colUpdatedAt="{ row }">{{
        row.updated_at ? new Date(row.updated_at).toLocaleString() : '-'
      }}</template>
      <template #colActions="{ row }">
        <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
        <el-button class="danger-button" size="small" type="text" @click="handleDelete(row)">删除</el-button>
      </template>
    </SchemaTablePage>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      class="page-dialog"
      @closed="handleDialogClosed"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-position="right"
        size="small"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="会员账号" prop="username">
              <el-input
                v-if="isEdit"
                v-model="formData.username"
                placeholder="请输入会员账号"
                :disabled="isEdit"
              ></el-input>
              <el-input
                v-else
                v-model="formData.username"
                type="textarea"
                rows="3"
                placeholder="请输入会员账号，多行请用换行分隔"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单日提款限额" prop="payout_limit">
              <el-input-number
                v-model="formData.payout_limit"
                class="limit-input"
                :controls="false"
                :min="0"
                :precision="2"
                placeholder="请输入单日提款限额"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData.remark" type="textarea" rows="3" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 操作记录弹窗 -->
    <el-dialog
      title="操作记录"
      :visible.sync="logDialogVisible"
      width="1200px"
      :close-on-click-modal="false"
      class="page-dialog center-dialog"
      @closed="handleLogDialogClosed"
    >
      <!-- 搜索区域 -->
      <div class="page-search">
        <el-form ref="logSearchFormRef" :inline="true" :model="logSearchForm" label-position="right" size="mini">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="会员账号">
                <el-input v-model="logSearchForm.username" placeholder="请输入会员账号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="操作人">
                <el-input v-model="logSearchForm.last_operator" placeholder="请输入操作人" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="操作时间">
                <DateTimeRangePicker v-model="logSearchForm.dateRange" class="withdraw-limit-date-range" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="3" style="text-align: right">
              <el-button size="mini" type="primary" @click="handleLogSearch">筛选</el-button>
              <el-button size="mini" @click="handleLogReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="page-content" style="padding: 20px 0 0">
        <!-- 表格区域 -->
        <el-table :data="logTableData" size="small" border stripe fit highlight-current-row style="width: 100%">
          <el-table-column :resizable="false" prop="player_username" label="会员账号" width="150"></el-table-column>
          <el-table-column :resizable="false" prop="operation" label="操作类型" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.operation === 'add'" type="success">添加</el-tag>
              <el-tag v-else-if="scope.row.operation === 'update'" type="primary">更新</el-tag>
              <el-tag v-else-if="scope.row.operation === 'delete'" type="danger">删除</el-tag>
              <el-tag v-else type="info">{{ scope.row.operation }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="before" label="变更前" min-width="200"></el-table-column>
          <el-table-column :resizable="false" prop="after" label="变更后" min-width="200"></el-table-column>
          <el-table-column :resizable="false" prop="username" label="操作人" width="120"></el-table-column>
          <el-table-column :resizable="false" prop="created_at" label="操作时间" width="160">
            <template slot-scope="scope">
              {{ scope.row.created_at ? new Date(scope.row.created_at).toLocaleString() : '-' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <!-- 分页组件 -->
        <el-pagination
          :current-page="logPagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="logPagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logPagination.total"
          @size-change="handleLogSizeChange"
          @current-change="handleLogCurrentChange"
        ></el-pagination>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// 引入mock数据
// import memberMock from '@/mock/daily-withdraw-limit';
import {
  changePayoutLimitLogs,
  payoutLimitAdd,
  payoutLimitDelete,
  payoutLimitList,
  payoutLimitUpdate,
} from '@/api/member/configuration'
import SchemaTablePage from '@/components/SchemaTablePage'
import DateTimeRangePicker from '@/components/DateTimeRangePicker'
import { datePickerOptions } from '@/pages/common/config/dataPicker'
import { centsToYuan } from '@/utils/amount'
import { toUnixSeconds } from '@/utils/time'
import MemberAccountCell from '@/components/MemberAccountCell.vue'

export default {
  name: 'DailyWithdrawLimit',
  components: { SchemaTablePage, DateTimeRangePicker, MemberAccountCell },
  data() {
    return {
      tableAttrs: {},
      defaultQuery: {
        username: '',
      },
      searchSchema: [
        { prop: 'username', label: '会员账号', component: 'input', componentProps: { clearable: true } },
        { component: 'actions' },
      ],
      tableColumns: [
        { type: 'index', label: '序号', width: 60, align: 'center', resizable: false },
        { prop: 'username', label: '会员账号', minWidth: 150, resizable: false, slot: 'username' },
        // { prop: 'level', label: '会员等级', minWidth: 100, resizable: false },
        { prop: 'payout_limit', label: '单日提款限额', minWidth: 100, resizable: false, slot: 'colPayoutLimit' },
        { prop: 'remark', label: '备注', minWidth: 160, resizable: false },
        { prop: 'last_operator', label: '最后操作人', minWidth: 120, resizable: false },
        { prop: 'updated_at', label: '最后操作时间', minWidth: 140, resizable: false, slot: 'colUpdatedAt' },
        { fixed: 'right', label: '操作', width: 120, align: 'center', resizable: false, slot: 'colActions' },
      ],

      // 弹窗控制
      dialogVisible: false,
      isEdit: false,
      dialogTitle: '',

      // 表单数据
      formData: {
        username: '',
        payout_limit: undefined,
        remark: '',
      },

      // 表单验证规则
      formRules: {
        username: [{ required: true, message: '请输入会员账号', trigger: 'blur' }],
        payout_limit: [
          { required: true, message: '请输入单日提款限额', trigger: 'blur' },
          { type: 'number', min: 0, message: '单日提款限额不能为负数', trigger: 'blur' },
        ],
      },

      // 操作记录弹窗
      logDialogVisible: false,
      logSearchForm: {
        username: '',
        last_operator: '',
        dateRange: [],
      },
      logTableData: [],
      logPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 时间范围选择器配置
      pickerOptions: datePickerOptions,
    }
  },
  methods: {
    request(params) {
      return payoutLimitList(params)
    },
    buildParams({ query, page, limit }) {
      return {
        page,
        page_size: limit,
        username: query?.username || '',
      }
    },
    parseResult(response) {
      return {
        list: response?.data?.list || [],
        total: response?.data?.total || 0,
      }
    },

    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增单日提款限制'
      this.formData = {
        username: '',
        payout_limit: undefined,
        remark: '',
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑单日提款限制'
      this.formData = {
        ...row,
        payout_limit: centsToYuan(row.payout_limit),
      }
      this.dialogVisible = true
    },

    // 删除
    async handleDelete(row) {
      this.$confirm(`确定要删除会员账号为${row.username}的提款限制吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const response = await payoutLimitDelete({
              username: row.username,
            })
            if (response.code === 0) {
              this.$message.success('删除成功')
              this.$refs.tablePageRef?.reload?.()
              this.$emit('update')
            } else {
              this.$message.error(response.msg || '删除失败')
            }
          } catch (error) {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },

    // 提交表单
    async handleSubmit() {
      try {
        // 使用Promise形式的validate方法
        const valid = await this.$refs.formRef.validate()
        if (valid) {
          let response
          if (this.isEdit) {
            // 编辑模式，只能编辑一个会员
            response = await payoutLimitUpdate({
              username: this.formData.username,
              payout_limit: this.formData.payout_limit * 100,
              remark: this.formData.remark,
            })
          } else {
            // 新增模式，支持多个会员账号，使用换行分隔
            const usernames = this.formData.username
              .split('\n')
              .map(item => item.trim())
              .filter(item => item)
            response = await payoutLimitAdd({
              username: usernames,
              payout_limit: this.formData.payout_limit * 100,
              remark: this.formData.remark,
            })
          }

          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.$refs.tablePageRef?.reload?.()
        }
      } catch (error) {
        console.log(error)
        // this.$message.error(this.isEdit ? '编辑失败' : '新增失败');
      }
    },

    // 处理弹窗关闭
    handleDialogClosed() {
      this.$refs.formRef?.resetFields()
    },

    // 显示操作记录
    handleShowLog() {
      this.logDialogVisible = true
      this.logPagination.currentPage = 1
      this.loadChangeLogs()
    },

    // 加载操作记录
    async loadChangeLogs() {
      try {
        // 将日期转换为时间戳（秒）
        const start_at =
          this.logSearchForm.dateRange && this.logSearchForm.dateRange[0]
            ? toUnixSeconds(this.logSearchForm.dateRange[0])
            : 0
        const end_at =
          this.logSearchForm.dateRange && this.logSearchForm.dateRange[1]
            ? toUnixSeconds(this.logSearchForm.dateRange[1])
            : 0

        const response = await changePayoutLimitLogs({
          page: this.logPagination.currentPage,
          page_size: this.logPagination.pageSize,
          username: this.logSearchForm.username,
          last_operator: this.logSearchForm.last_operator,
          start_at: start_at,
          end_at: end_at,
        })
        if (response.code === 0) {
          this.logTableData = response.data.list
          this.logPagination.total = response.data.total
        }
      } catch (error) {
        this.$message.error('加载操作记录失败')
      }
    },

    // 搜索操作记录
    handleLogSearch() {
      this.logPagination.currentPage = 1
      this.loadChangeLogs()
    },

    // 重置操作记录搜索
    handleLogReset() {
      this.logSearchForm = {
        username: '',
        last_operator: '',
        dateRange: [],
      }
      this.logPagination.currentPage = 1
      this.loadChangeLogs()
    },

    // 处理操作记录分页大小变化
    handleLogSizeChange(size) {
      this.logPagination.pageSize = size
      this.loadChangeLogs()
    },

    // 处理操作记录分页当前页码变化
    handleLogCurrentChange(page) {
      this.logPagination.currentPage = page
      this.loadChangeLogs()
    },

    // 处理操作记录弹窗关闭
    handleLogDialogClosed() {
      this.$refs.logSearchFormRef?.resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  margin-bottom: 10px;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}

.page-dialog {
  // ::v-deep {
  //   .el-form--label-right {
  //     .el-form-item {
  //       display: flex;
  //       justify-items: center;
  //       width: 100%;
  //     }

  //     .el-form-item__label {
  //       flex: none;
  //       padding-right: 8px;
  //     }

  //     .el-form-item__content {
  //       flex: auto;
  //       min-width: 0;

  //       .el-select {
  //         width: 100%;
  //       }
  //     }
  //   }
  // }

  :deep(.limit-input) {
    width: 100%;

    input {
      text-align: left;
    }
  }
}
.withdraw-limit-date-range {
  width: 100%;
}
</style>
